<!-- 运行监控页面 -->
<template>
    <div class='pagebg box box_v' id="page">
        <div class="title">{{title}}</div>
        <div class="content box box_f1">
            <div class="col-1 box box_v">
                <div class="box_f1 bgc-noselect" :class="{bgcSelect:isActive==0}"
                    @mouseover="inCard(0)" @mouseout="outCard()">
                    <chart-card title="社区生活服务">
                        <chart-one @setMarkers="setMarkers"></chart-one>
                    </chart-card>
                </div>
                <div class="box_f1 bgc-noselect" :class="{bgcSelect:isActive==1}"
                    @mouseover="inCard(1)" @mouseout="outCard()">
                    <chart-card title="社区办理">
                        <chart-two @setMarkers="setMarkers"></chart-two>
                    </chart-card>
                </div>
                <div class="box_f1 bgc-noselect" :class="{bgcSelect:(isActive==2)}"
                    @mouseover="inCard(2)" @mouseout="outCard()">
                    <chart-card title="公服企业">
                        <table-one></table-one>
                    </chart-card>
                </div>

                <div class="box_f1 bgc-noselect" :class="{bgcSelect:(isActive==3)}"
                    @mouseover="inCard(3)" @mouseout="outCard()">
                    <chart-card title="社工/党员办理">
                        <chart-three></chart-three>
                    </chart-card>
                </div>
            </div>
            <div class="col-3 box box_v">
                <!--时间-->
                <!-- <div class="time box">
                    <div class="iconfont icon-shijian shijian"></div>
                    <div class="">截止至：2019-05-09 08：00</div>
                </div> -->
                <!--地图-->
                <div class="box_f1 mapcontainer" id="container">
                    <!-- <div id="container" class="mapcontainer">
                    </div> -->
                </div>
                <!--今日概况-->
                <div class="countbox box">
                    <count></count>
                </div>
            </div>
            <div class="col-1  box box_v">
                <div class="box_f1 bgc-noselect" :class="{bgcSelect:(isActive==4)}"
                     @mouseover="inCard(4)" @mouseout="outCard()">
                    <chart-card title="社区活动次数统计">
                        <chart-four @setMarkers="setMarkers"></chart-four>
                    </chart-card>
                </div>
                <div class="box_f2 bgc-noselect" :class="{bgcSelect:(isActive==5)}"
                    @mouseover="inCard(5)" @mouseout="outCard()">
                    <chart-card title="活动签到报名情况统计" :big="true">
                        <chart-five></chart-five>
                    </chart-card>
                </div>
                <div class="box_f1 bgc-noselect" :class="{bgcSelect:(isActive==6)}"
                     @mouseover="inCard(6)" @mouseout="outCard()">
                    <chart-card title="活跃社区">
                        <table-two></table-two>
                    </chart-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
var map,markerList,infoWindow,timer
import chartCard from './components/chartcard';
/**统计图们 */
import chartOne from './components/chart1';
import chartTwo from './components/chart2';
import chartThree from './components/chart3';
import chartFour from './components/chart4';
import chartFive from './components/chart5';
/**表格们 */
import tableOne from './components/table1';
import tableTwo from './components/table2';
/**今日概况 */
import count from './components/count';
import { setInterval, clearInterval } from 'timers';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {chartCard,chartOne,chartTwo,chartThree,chartFour,chartFive,tableOne,tableTwo,count},
    provide:{
       isSmallWidth:document.body.offsetWidth<1610?true:false
    },
    data() {
    //这里存放数据
        return {
            title:'',
            isActive:null,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        /**鼠标悬浮,点击改变背景色 */
        inCard(val){
            this.isActive = val
        },
        outCard(){
            this.isActive = null
        },
        /**获取街道范围 */
        getStreetPosition(){
            var url = this.urlobj.getStreetPosition

            this.$get(url).then(res => {
                if (res.isSucceed) {
                    if(res.rows[0]){
                        this.title = res.rows[0].streetName.split('街道')[0]+'街道系统概况'
                        res.rows[0].coordinate && this.drawMap(res.rows[0].coordinate)
                    }else{
                        this.getAreaAndStreet()
                    }

                }
            }).catch(e=>{

            })
        },
        /**根据坐标绘制范围 */
        drawMap(data){
            map = new AMap.Map('container', {
                resizeEnable: true, //是否监控地图容器尺寸变化
                mapStyle: "amap://styles/0dd55e5d7d8ea7df349126652ba128bf",
                showLabel: false,
            });
            let polygons = []
            var newdata = JSON.parse(data).map(item=>{
                return new AMap.LngLat(item.lng,item.lat)
            })
            var bounds = []
            bounds[0] = newdata
            if (bounds) {

                for (var i = 0, l = bounds.length; i < l; i++) {
                    console.log(bounds[i])
                    var polygon = new AMap.Polygon({
                        map: map,
                        strokeWeight: 5,
                        strokeColor: '#00eaff',
                        fillColor: '#070e3d',
                        fillOpacity: 0,
                        path: bounds[i]
                    });
                    polygons.push(polygon);
                }
                map.add(polygons)
                map.setFitView(polygons);//地图自适应
            }
        },
        /**获取行政区域 */
        getAreaAndStreet(){
            var url = this.urlobj.getAreaAndStreet

            this.$get(url).then(res => {
                if (res.isSucceed) {
                    this.title = res.rows[0].streetName.split('街道')[0]+'街道系统概况'
                    this.initMap(res.rows[0].areaName)
                }
            }).catch(e=>{

            })
        },
        initMap(areaName){
            let that = this
            // 初始化地图
            map = new AMap.Map('container', {
                resizeEnable: true, //是否监控地图容器尺寸变化
                //mapStyle: "amap://styles/b8ddafad542c6c4895a2c8618146933a",//透明背景图
                mapStyle: "amap://styles/0dd55e5d7d8ea7df349126652ba128bf",
                //mapStyle: "amap://styles/darkblue",
                showLabel: false,
                //features:['road']
            });
           // AMap.plugin('AMap.DistrictSearch', function () {
                var districtSearch = new AMap.DistrictSearch({
                    // 关键字对应的行政区级别，country表示国家
                    subdistrict: 0,   //获取边界不需要返回下级行政区
                    extensions: 'all',  //返回行政区边界坐标组等具体信息
                    level: 'district'  //查询行政级别为 市
                })

                // 搜索所有省/直辖市信息
                districtSearch.search(areaName, function(status, result) {
                    console.log(status)
                    console.log(result)
                    // 查询成功时，result即为对应的行政区信息
                    if(status=='complete'){
                        console.log('------here------')
                        console.log(result.districtList[0])
                        // {
                        //     O: 116.72552400000001
                        //     P: 39.624071
                        //     lat: 39.624071
                        //     lng: 116.725524
                        // }
                        that.getData(result.districtList[0]);
                    }
                })
            //})

        },
        getData(data,level) {
            let polygons = []
            var bounds = data.boundaries;
            console.log(bounds)

           // var data = [{"lng":116.657875,"lat":39.907886},{"lng":116.658475,"lat":39.903013},{"lng":116.657789,"lat":39.900083},{"lng":116.656373,"lat":39.898042},{"lng":116.65633,"lat":39.897087},{"lng":116.673625,"lat":39.896758},{"lng":116.69152,"lat":39.899919},{"lng":116.693966,"lat":39.901071},{"lng":116.696713,"lat":39.903244},{"lng":116.697807,"lat":39.902182},{"lng":116.70153,"lat":39.904873},{"lng":116.699202,"lat":39.906561},{"lng":116.693966,"lat":39.911235},{"lng":116.690962,"lat":39.915053},{"lng":116.6871,"lat":39.913408},{"lng":116.68328,"lat":39.912585},{"lng":116.676714,"lat":39.908898},{"lng":116.676672,"lat":39.908898}]
            // var newdata = data.map(item=>{
            //     return new AMap.LngLat(item.lng,item.lat)
            // })
            // var bounds = []
            // bounds[0] = newdata
            // console.log(bounds)
            if (bounds) {

                for (var i = 0, l = bounds.length; i < l; i++) {
                    console.log(bounds[i])
                    var polygon = new AMap.Polygon({
                        map: map,
                        strokeWeight: 1,
                        strokeColor: '#008eff',
                        fillColor: '#151c54',
                        fillOpacity: 0.9,
                        path: bounds[i]
                    });
                    polygons.push(polygon);
                }
                map.add(polygons)
                map.setFitView(polygons);//地图自适应
                //map.zoomIn()
                //this.setMarkers([])
                //map.setZoom(10.5)
            }
        },
        setMarkers (data) {
            console.log('------setMarkers------')
            console.log(data)
            //if(data.isClear) map.remove(markerList)
            if (markerList) map.remove(markerList)
            markerList=[]

            data.list.forEach((item,index) => {
                var circleMarker = new AMap.CircleMarker({
                    center:new AMap.LngLat(JSON.parse(item.position).x,JSON.parse(item.position).y),
                    radius:3+Math.random()*2,//3D视图下，CircleMarker半径不要超过64px
                    strokeColor:data.color,
                    strokeWeight:0,
                    strokeOpacity:item.opacity,
                    fillColor:data.color,
                    fillOpacity:item.opacity,
                    //fillOpacity:Math.random().toFixed(1),
                    //fillColor:'rgba(0,0,255,1)',
                    zIndex:10,
                    bubble:true,
                    cursor:'pointer',
                    clickable: true
                })
                //console.log(JSON.parse(item.position).x,JSON.parse(item.position).y,item.name)
                circleMarker.name = item.name
                circleMarker.on('mouseover',this.overMarker)
                circleMarker.on('mouseout',this.outMarker)
                //map.add(circleMarker)
                markerList.push(circleMarker)
            })
            if (markerList.length > 0) {
                console.log(markerList)
                map.add(markerList)
               // map.setCenter(markerList[0].getPosition())
            }
        },
        overMarker(e){
            console.log('----hover---------')
            console.log(e)
            var name = e.target.name
            infoWindow = new AMap.InfoWindow({
                offset: new AMap.Pixel(0, -35),
                isCustom: true,  //使用自定义窗体
                content: this.createInfoWindow(name),
            });
            infoWindow.open(map,[e.lnglat.lng,e.lnglat.lat])
        },
        createInfoWindow (name) {
            var info = document.createElement("div");
            info.innerHTML = name
            info.className = "infoBox"
            info.setAttribute("style","border:1px solid #7192f1;border-radius: 4px;background: #12153e;color:#02d7ff;font-size: 18px;padding:10px 20px;")
            return info
        },
        outMarker () {
            infoWindow.close()
        },
        /**页面自己混动 */
        autoView(){
            timer = setInterval(()=>{
               if(this.isActive == 6){
                   this.isActive = 0
               }else{
                    this.isActive ++
               }
            },5000)
        },
        /**页面全屏预览 */
        launchFullscreen(element) {
            element = document.getElementById('page')
            //此方法不可以在異步任務中執行，否則火狐無法全屏
            if(element.requestFullscreen) {
                element.requestFullscreen();
            } else if(element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if(element.msRequestFullscreen) {
                element.msRequestFullscreen();
            } else if(element.oRequestFullscreen) {
                element.oRequestFullscreen();
            } else if(element.webkitRequestFullscreen) {
                element.webkitRequestFullScreen();
            } else {
                var docHtml = document.documentElement;
                var docBody = document.body;
                var videobox = document.getElementById('videobox');
                var width = window.screen.width;
                var height = window.screen.height;
                var cssText = "width:" + width + ";height:" + height + ";overflow:hidden;";
                docHtml.style.cssText = cssText;
                docBody.style.cssText = cssText;
                document.IsFullScreen = true;
            }
        }

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        //this.getAreaAndStreet()
        this.getStreetPosition()
        //this.isActive = 0;
        //this.autoView()

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {
        clearInterval(timer)
        //timer = null
    }, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.pagebg{
    width: 100%;
    height: 100%;
    background-image: url('../../assets/images/monitor/bg.jpg');
    background-size: 100%;
}
.title{
    width: 100%;
    height: 60px;
    background-image: url('../../assets/images/monitor/titlebg.png');
    background-size: 100%;
    color:#fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 6px;
}
.content{
    margin:20px;
}
.col-1{
    width:20%;
}
.col-1>div{
    // margin-bottom: 30px;
    // background-image: url('../../assets/images/monitor/rect-s.png');
    // background-size: 100% 100%;
    margin-bottom: 30px;

}
@media screen and (max-width: 1600px) {
    .col-1>div{
        margin-bottom: 10px;

    }
}

.col-1>div:last-child{
    margin-bottom: 0
}
.col-3{
    width:60%;
    position: relative;
}
.bgc-noselect{
    // width: 100%;
    // height: 100%;
    background-image: linear-gradient(to bottom , rgba(71, 41, 133,.5), rgba(32, 141, 175,.2),rgba(255,255,255,0));
}
.bgcSelect{
    background-image:none !important;
    background-color:#0c0e2f !important;
}
.box_f2{
    flex:2
}
.box_f3{
    flex:4
}

/*地图*/
.mapcontainer{
   // height: 100%;
    //height: 90%;
    margin:0 20px;
    background:#1f2764;
}
/*今日概况*/
.countbox{
    // position: absolute;
    // left: 0;
    // bottom: 0;
}
/*右上角时间*/
.time{
    position: absolute;
    right: 15px;
    top: 0;
    color:#bdc0d3;
    font-size: 13px;

}
.shijian{
    color: #7078b7;
    margin-right: 8px;
    font-size: 18px;
    margin-top: -2px;
}
.infoBox{
    border:1px solid #7192f1;
    border-radius: 4px;
    background: #12153e;
    color:#02d7ff;
    font-size: 18px;
    padding:10px 20px;
}
</style>